import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import {
  authUserList,
  authGrpList,
  userDelete,
  userAuthList,
} from 'lib/api/auth';
import { showSuccessSnackbar } from 'modules/snackbar';

import NewButton from 'components/molecules/NewButton';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewAutoComplete from 'components/molecules/NewSelectBox/NewAutoComplete';

import AccountModal from './AccountModal';

const Account = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [initialization, setInitialization] = useState(false);
  const initParams = {
    grpNo: null,
    sort: 'desc',
    order: 'MOB_ID_USE_YN',
  };
  const [params, setParams] = useState(initParams);
  const [groupList, setGroupList] = useState([]);
  const initModal = {
    open: false,
    type: '',
    params: {},
    data: {},
    headerTitle: t('권한 리스트'),
    confirmBtnTitle: t('확인'),
  };
  const [modal, setModal] = useState(initModal);

  useEffect(() => {
    authGrpList()
      .then((response) => {
        const { data } = response.data;
        setGroupList(data);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      makeRowFunc: (data) => {
        return (
          <TableBtnWrap>
            <NewButton
              title={t('권한 리스트')}
              icon="faUserAlt"
              iconBtn
              onClick={(e) => handleModalOpen(data)}
              disableRipple
            />
          </TableBtnWrap>
        );
      },
    });
    return result;
  })();

  const customized = {
    USER_ID: { orderFlag: true },
    USER_NAME: {
      makeHead: (headsMap) => {
        return t('유형 구분');
      },
      orderFlag: true,
    },
    DEPT_PATH: { orderFlag: true },
    POSITION: { orderFlag: true },
    MOB_ID_USE_YN: { orderFlag: true },
    REG_DTTM: { orderFlag: true },
    LAST_LOGIN: { orderFlag: true },
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const handleModalOpen = (userData) => {
    userAuthList({ userId: userData['USER_ID'] })
      .then((response) => {
        const { data } = response.data;
        setModal({ ...initModal, open: true, params: userData, data: data });
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error.message,
          option: { type: 'error' },
        });
      })
      .finally(() => {});
  };

  const handleModalClose = () => {
    setModal({ ...modal, open: false });
  };

  const handleUserDelete = () => {
    userDelete({ userId: modal.params['USER_ID'] })
      .then((response) => {
        handleClickSnackbar({
          message: response.data.message,
          option: { type: 'error' },
        });
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error.message,
          option: { type: 'error' },
        });
      })
      .finally((f) => {
        handleModalClose();
      });
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <NewFilterWrap>
        <NewAutoComplete
          list={groupList}
          label={t('그룹명')}
          name="grpNo"
          valueKey="GRP_NO"
          labelKey="GRP_NAME"
          getParam={getParam}
          params={params}
          style={{ width: 250 }}
          loading={false}
        />
      </NewFilterWrap>
      <NewTableContainer
        dataReqPromise={authUserList}
        getParam={getParam}
        params={params}
        useTotal={false}
        useFetch={false}
        customized={customized}
        addColumnList={addColumnList}
        useExcel={false}
        useFullScreen={false}
      />
      {modal.open && (
        <AccountModal
          modal={modal}
          handleClose={handleModalClose}
          handleUserDelete={handleUserDelete}
        />
      )}
    </>
  );
};

export default Account;
